"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
var _typographyStylex = require("web/shared/typography.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * The table vocabulary every performance console table speaks.
 *
 * Shared because a reader moves between them, and a cell that was padded or
 * ruled differently in each would read as tables from different tools.
 *
 * The divided cells are the device that makes a wide row of figures legible: a
 * rule on both sides of every cell, collapsed by the table into one line
 * between neighbors and kept at the outer edges, so the first and last
 * columns are bounded rather than trailing off.
 */
const styles = exports.styles = {
  tableWrap: {
    width: "xh8yej3",
    overflowX: "xw2csxc",
    $$css: true
  },
  table: {
    width: "xh8yej3",
    borderCollapse: "x1mwwwfo",
    fontSize: "x1q2zfhj",
    $$css: true
  },
  headCell: {
    textAlign: "xdpxx8g",
    paddingTop: "x181mwm9",
    paddingBottom: "xvfl3op",
    paddingLeft: "x4gs2og",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "xbygrs",
    backgroundColor: "x1498qn9",
    borderBottomWidth: "xso031l",
    borderBottomStyle: "x1q0q8m5",
    borderBottomColor: "x196gm1a",
    color: "xcdm7ny",
    fontWeight: "x1s688f",
    whiteSpace: "xuxw1ft",
    $$css: true
  },
  numericHeadCell: {
    textAlign: "x1hr2gdg",
    paddingTop: "x181mwm9",
    paddingBottom: "xvfl3op",
    paddingLeft: "x4gs2og",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "xbygrs",
    backgroundColor: "x1498qn9",
    borderBottomWidth: "xso031l",
    borderBottomStyle: "x1q0q8m5",
    borderBottomColor: "x196gm1a",
    color: "xcdm7ny",
    fontWeight: "x1s688f",
    whiteSpace: "xuxw1ft",
    $$css: true
  },
  cell: {
    paddingTop: "x181mwm9",
    paddingBottom: "xvfl3op",
    paddingLeft: "x4gs2og",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "xbygrs",
    borderBottomWidth: "xso031l",
    borderBottomStyle: "x1q0q8m5",
    borderBottomColor: "x196gm1a",
    verticalAlign: "x16dsc37",
    $$css: true
  },
  numericCell: {
    paddingTop: "x181mwm9",
    paddingBottom: "xvfl3op",
    paddingLeft: "x4gs2og",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "xbygrs",
    borderBottomWidth: "xso031l",
    borderBottomStyle: "x1q0q8m5",
    borderBottomColor: "x196gm1a",
    verticalAlign: "x16dsc37",
    textAlign: "x1hr2gdg",
    whiteSpace: "xuxw1ft",
    fontFamily: "xm3uy08",
    $$css: true
  },
  dividedCell: {
    borderLeftWidth: "xe0pwq",
    borderInlineStartWidth: null,
    borderInlineEndWidth: null,
    borderLeftStyle: "x19ypqd9",
    borderInlineStartStyle: null,
    borderInlineEndStyle: null,
    borderLeftColor: "xemesb5",
    borderInlineStartColor: null,
    borderInlineEndColor: null,
    borderRightWidth: "xs1s249",
    borderRightStyle: "x32b0ac",
    borderRightColor: "xwx0bfk",
    $$css: true
  }
};